import { render } from "./AboutPageTwo.vue?vue&type=template&id=4b77e1c8"
import script from "./AboutPageTwo.vue?vue&type=script&lang=js"
export * from "./AboutPageTwo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\digitaldistribution.io-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__